import io from 'socket.io-client';
import config from '../config/config';

const socketInstance = (nameSpace, query) =>
  io(`${config.server}/${nameSpace}`, {
    reconnectionDelay: 1000,
    reconnectionDelayMax: 1000,
    randomizationFactor: 0,
    pingTimeout: 30000,
    autoConnect: false,
    perMessageDeflate: true,
    forceNew: false,
    transports: ['websocket'],
    allowUpgrades: false,
    query,
  });

const socketIo = {
  loginSocket: socketInstance('login', null),
  locationSocket: null,
  otherLocations: [],
  establishConnection(nameSpace, query, externalSocket = false) {
    if (externalSocket) {
      const instance = socketInstance(nameSpace, query);
      this.otherLocations.push(instance);
      return instance;
    }

    this.locationSocket = socketInstance(nameSpace, query);
    return this.locationSocket;
  },
  clearOtherLocations() {
    this.otherLocations = [];
  },
};

export default socketIo;
